import React, { Component } from 'react';
import { Play, Shield, Eye, Clock, Users, CheckCircle, Star, ArrowRight, Phone, Mail, MapPin } from 'lucide-react';

class Monitor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeFeature: 0,
      stats: [
        { number: '24/7', label: 'Monitoring Coverage' },
        { number: '99.9%', label: 'Uptime Guarantee' },
        { number: '100+', label: 'Satisfied Clients' },
        { number: '<30s', label: 'Response Time' }
      ],
      features: [
        {
          icon: <Eye className="w-6 h-6" />,
          title: 'Real-Time Surveillance',
          description: 'Continuous monitoring with instant alerts and notifications for any suspicious activity.'
        },
        {
          icon: <Shield className="w-6 h-6" />,
          title: 'Advanced Security Analytics',
          description: 'AI-powered threat detection and behavioral analysis for proactive security measures.'
        },
        {
          icon: <Clock className="w-6 h-6" />,
          title: '24/7 Professional Monitoring',
          description: 'Round-the-clock surveillance by certified security professionals and trained operators.'
        },
        {
          icon: <Users className="w-6 h-6" />,
          title: 'Multi-Site Management',
          description: 'Centralized monitoring solution for multiple locations with unified dashboard control.'
        }
      ],
      services: [
        {
          title: 'Remote Video Monitoring',
          description: 'Professional security operators monitor your premises remotely, providing immediate response to incidents.',
          features: ['Live video feeds', 'Motion detection alerts', 'Instant notifications', 'Incident recording']
        },
        {
          title: 'AI-Powered Analytics',
          description: 'Advanced artificial intelligence analyzes video feeds to detect unusual patterns and potential threats.',
          features: ['Behavioral analysis', 'Object recognition', 'Perimeter detection', 'Crowd monitoring']
        },
        {
          title: 'Mobile Monitoring Solutions',
          description: 'Access your security system from anywhere with our mobile-friendly monitoring platform.',
          features: ['Mobile app access', 'Push notifications', 'Live streaming', 'Remote controls']
        },
        {
          title: 'Integration Services',
          description: 'Seamlessly integrate with existing security systems and business management platforms.',
          features: ['System integration', 'API connectivity', 'Custom dashboards', 'Third-party compatibility']
        }
      ],
      testimonials: [
        {
          name: 'Sarah Johnson',
          company: 'Metro Shopping Center',
          rating: 5,
          text: 'The live monitoring service has significantly improved our security posture. The response time is incredible.'
        },
        {
          name: 'Michael Chen',
          company: 'Industrial Complex Ltd.',
          rating: 5,
          text: 'Professional service with cutting-edge technology. Their team detected and prevented multiple incidents.'
        },
        {
          name: 'Lisa Rodriguez',
          company: 'Residential Community',
          rating: 5,
          text: 'Peace of mind knowing our community is monitored 24/7 by experienced security professionals.'
        }
      ]
    };
  }

  componentDidMount() {
    // Auto-rotate features every 4 seconds
    this.featureInterval = setInterval(() => {
      this.setState(prevState => ({
        activeFeature: (prevState.activeFeature + 1) % prevState.features.length
      }));
    }, 4000);
  }

  componentWillUnmount() {
    if (this.featureInterval) {
      clearInterval(this.featureInterval);
    }
  }

  setActiveFeature = (index) => {
    this.setState({ activeFeature: index });
  }

  render() {
    const { activeFeature, stats, features, services, testimonials } = this.state;

    const styles = {
      root: {
        '--primary-dark': '#010A1A',
        '--secondary-dark': '#002C58',
        '--text-primary': '#ffffff',
        '--text-secondary': '#94a3b8',
        '--box-dark-bg': '#1a2332',
        '--icons-color': '#155EEF',
        '--accent-cyan': '#06b6d4',
        '--accent-blue': '#3b82f6'
      }
    };

    return (
      <div className="min-vh-100" 
           style={{
             backgroundColor: 'var(--primary-dark)',
             color: 'var(--text-primary)',
             fontFamily: 'system-ui, -apple-system, sans-serif'
           }}>
        
        {/* Banner Section */}
        <section className="general-banner">
          <div className="container">
            <div className="general-content">
              <h1 className="hero-title orbitron">Live Video Monitoring & Security</h1>
              <p className="hero-subtitle">Advanced 24/7 surveillance solutions with AI-powered threat detection and professional monitoring services</p>
            </div>
          </div>
        </section>
        {/* <section className="general-banner py-5" 
                 style={{
                   background: `linear-gradient(135deg, var(--secondary-dark) 0%, var(--primary-dark) 100%)`,
                   minHeight: '50vh',
                   display: 'flex',
                   alignItems: 'center'
                 }}>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-10">
                <div className="general-content">
                  <h1 className="hero-title display-3 fw-bold mb-4" 
                      style={{
                        fontFamily: 'Orbitron, monospace',
                        color: 'var(--text-primary)',
                        textShadow: '0 0 20px rgba(21, 94, 239, 0.3)'
                      }}>
                    Live Video Monitoring & Security
                  </h1>
                  <p className="hero-subtitle " 
                     style={{ color: 'var(--text-secondary)'}}>
                    Advanced 24/7 surveillance solutions and professional monitoring services
                  </p>
                  <div className="d-flex flex-wrap gap-3">
                    <button className="btn btn-lg px-4 py-2 d-flex align-items-center gap-2"
                            style={{
                              backgroundColor: 'var(--accent-blue)',
                              border: 'none',
                              borderRadius: '8px',
                              color: 'white',
                              fontWeight: '600'
                            }}>
                      Get Started <ArrowRight className="w-4 h-4" />
                    </button>
                    <button className="btn btn-outline-light btn-lg px-4 py-2 d-flex align-items-center gap-2">
                      <Play className="w-4 h-4" /> Watch Demo
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 text-center">
                <div className="position-relative">
                  <div className="d-inline-block p-4 rounded-circle" 
                       style={{
                         backgroundColor: 'var(--box-dark-bg)',
                         border: '2px solid var(--accent-cyan)',
                         boxShadow: '0 0 30px rgba(6, 182, 212, 0.3)'
                       }}>
                    <Shield className="w-5 h-5" style={{ width: '80px', height: '80px', color: 'var(--accent-cyan)' }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        {/* Stats Section */}
        {/* <section className="py-5" style={{ backgroundColor: 'var(--box-dark-bg)' }}>
          <div className="container">
            <div className="row g-4">
              {stats.map((stat, index) => (
                <div key={index} className="col-lg-3 col-md-6">
                  <div className="text-center p-4 h-100 rounded-3" 
                       style={{
                         backgroundColor: 'var(--primary-dark)',
                         border: '1px solid var(--secondary-dark)',
                         transition: 'transform 0.3s ease'
                       }}
                       onMouseEnter={(e) => e.target.style.transform = 'translateY(-5px)'}
                       onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
                    <h2 className="display-4 fw-bold mb-2" 
                        style={{ color: 'var(--accent-cyan)' }}>
                      {stat.number}
                    </h2>
                    <p className="mb-0" style={{ color: 'var(--text-secondary)' }}>
                      {stat.label}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section> */}

        {/* Features Section */}
        <section className="py-5">
          <div className="container">
            <div className="row mb-5">
              <div className="col-12 text-center">
                <h2 className="display-5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                  Advanced Security Features
                </h2>
                <p className="lead" style={{ color: 'var(--text-secondary)' }}>
                  Cutting-edge technology meets professional expertise
                </p>
              </div>
            </div>
            <div className="row g-4">
              {features.map((feature, index) => (
                <div key={index} className="col-lg-6 col-md-6">
                  <div className={`p-4 h-100 rounded-3 cursor-pointer transition-all ${
                         activeFeature === index ? 'border-2' : 'border-1'
                       }`}
                       style={{
                         backgroundColor: activeFeature === index ? 'var(--secondary-dark)' : 'var(--box-dark-bg)',
                         borderColor: activeFeature === index ? 'var(--accent-blue)' : 'var(--secondary-dark)',
                         transition: 'all 0.3s ease',
                         cursor: 'pointer'
                       }}
                       onClick={() => this.setActiveFeature(index)}>
                    <div className="d-flex align-items-start gap-3">
                      <div className="p-3 rounded-2 flex-shrink-0" 
                           style={{ 
                             backgroundColor: 'var(--icons-color)', 
                             color: 'white' 
                           }}>
                        {feature.icon}
                      </div>
                      <div>
                        <h4 className="fw-bold mb-2" style={{ color: 'var(--text-primary)' }}>
                          {feature.title}
                        </h4>
                        <p className="mb-0" style={{ color: 'var(--text-secondary)' }}>
                          {feature.description}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="py-5" style={{ backgroundColor: 'var(--box-dark-bg)' }}>
          <div className="container">
            <div className="row mb-5">
              <div className="col-12 text-center">
                <h2 className="display-5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                  Our Monitoring Services
                </h2>
                <p className="lead" style={{ color: 'var(--text-secondary)' }}>
                  Comprehensive security solutions tailored to your needs
                </p>
              </div>
            </div>
            <div className="row g-4">
              {services.map((service, index) => (
                <div key={index} className="col-lg-6">
                  <div className="p-4 h-100 rounded-3" 
                       style={{
                         backgroundColor: 'var(--primary-dark)',
                         border: '1px solid var(--secondary-dark)'
                       }}>
                    <h4 className="fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                      {service.title}
                    </h4>
                    <p className="mb-3" style={{ color: 'var(--text-secondary)' }}>
                      {service.description}
                    </p>
                    <ul className="list-unstyled">
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="d-flex align-items-center gap-2 mb-2">
                          <CheckCircle className="w-4 h-4 flex-shrink-0" 
                                      style={{ color: 'var(--accent-cyan)' }} />
                          <span style={{ color: 'var(--text-secondary)' }}>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        {/* <section className="py-5">
          <div className="container">
            <div className="row mb-5">
              <div className="col-12 text-center">
                <h2 className="display-5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                  Client Testimonials
                </h2>
                <p className="lead" style={{ color: 'var(--text-secondary)' }}>
                  Trusted by businesses and communities worldwide
                </p>
              </div>
            </div>
            <div className="row g-4">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="col-lg-4">
                  <div className="p-4 h-100 rounded-3" 
                       style={{
                         backgroundColor: 'var(--box-dark-bg)',
                         border: '1px solid var(--secondary-dark)'
                       }}>
                    <div className="d-flex gap-1 mb-3">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <Star key={i} className="w-4 h-4" 
                              style={{ color: '#fbbf24', fill: '#fbbf24' }} />
                      ))}
                    </div>
                    <p className="mb-3" style={{ color: 'var(--text-secondary)' }}>
                      "{testimonial.text}"
                    </p>
                    <div className="border-top pt-3" 
                         style={{ borderColor: 'var(--secondary-dark) !important' }}>
                      <h6 className="fw-bold mb-1" style={{ color: 'var(--text-primary)' }}>
                        {testimonial.name}
                      </h6>
                      <small style={{ color: 'var(--text-secondary)' }}>
                        {testimonial.company}
                      </small>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section> */}

        {/* CTA Section */}
        <section className="py-5" 
                 style={{
                   background: `linear-gradient(135deg, var(--secondary-dark) 0%, var(--accent-blue) 100%)`
                 }}>
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <h2 className="display-5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                  Ready to Secure Your Property?
                </h2>
                <p className="lead mb-4" style={{ color: 'var(--text-primary)' }}>
                  Get started with our professional live video monitoring services today
                </p>
                <div className="d-flex flex-wrap justify-content-center gap-3">
                  <button className="btn btn-light btn-lg px-4 py-2 d-flex align-items-center gap-2">
                    <Phone className="w-4 h-4" /> Call Now: +1 (403) 992-1672
                  </button>
                  {/* <button className="btn btn-outline-light btn-lg px-4 py-2 d-flex align-items-center gap-2">
                    <Mail className="w-4 h-4" /> Get Free Quote
                  </button> */}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Info Section */}
        {/* <section className="py-4" style={{ backgroundColor: 'var(--box-dark-bg)' }}>
          <div className="container">
            <div className="row g-4">
              <div className="col-md-4 text-center">
                <div className="d-flex align-items-center justify-content-center gap-2">
                  <Phone className="w-5 h-5" style={{ color: 'var(--accent-cyan)' }} />
                  <span style={{ color: 'var(--text-secondary)' }}>24/7 Support: +1 (555) 123-4567</span>
                </div>
              </div>
              <div className="col-md-4 text-center">
                <div className="d-flex align-items-center justify-content-center gap-2">
                  <Mail className="w-5 h-5" style={{ color: 'var(--accent-cyan)' }} />
                  <span style={{ color: 'var(--text-secondary)' }}>security@company.com</span>
                </div>
              </div>
              <div className="col-md-4 text-center">
                <div className="d-flex align-items-center justify-content-center gap-2">
                  <MapPin className="w-5 h-5" style={{ color: 'var(--accent-cyan)' }} />
                  <span style={{ color: 'var(--text-secondary)' }}>Nationwide Coverage</span>
                </div>
              </div>
            </div>
          </div>
        </section> */}
      </div>
    );
  }
}

export default Monitor;